import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import {
  addDischargeArrayItem,
  removeDischargeArrayItem,
} from "../../../../Redux/actions/dischargeActions";
import DischargeService from "../../../../Services/DischargeService";

const MASTER_PAYLOAD = { activeYn: "Y", pageNo: 1, pageSize: 30 };

export default function CarePlan() {
  const dispatch = useDispatch();
  const dischargeCarePlanDtls = useSelector(
    (state) => state.discharge?.dischargeCarePlanDtls || []
  );

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    DischargeService.GetDischargeCarePlanMaster(MASTER_PAYLOAD)
      .then((res) => {
        const data = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.data?.data)
          ? res.data.data
          : [];
        setOptions(data);
      })
      .catch((err) => console.error("CarePlan fetch error:", err))
      .finally(() => setLoading(false));
  }, []);

  const isChecked = (carePlanCode) =>
    dischargeCarePlanDtls.some((item) => item.carePlanCode === carePlanCode);

  const handleToggleActivity = (act) => {
    const code = act.carePlanCode || act.code || act.id;
    const name = act.carePlanName || act.name || act.description || "";
    const existingIndex = dischargeCarePlanDtls.findIndex(
      (item) => item.carePlanCode === code
    );
    if (existingIndex > -1) {
      dispatch(removeDischargeArrayItem("dischargeCarePlanDtls", existingIndex));
    } else {
      dispatch(
        addDischargeArrayItem("dischargeCarePlanDtls", {
          carePlanId: dischargeCarePlanDtls.length + 1,
          carePlanCode: code,
          carePlanName: name,
          status: 1,
        })
      );
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-2 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        11. Care Plan ({dischargeCarePlanDtls.length} Selected)
      </h3>
      <label className="block text-xs font-semibold mb-2 text-gray-700">
        Select Activity Type
      </label>

      {loading && (
        <div className="flex items-center gap-2 py-3 text-[12px] text-gray-400">
          <FaSpinner className="animate-spin" /> Loading care plan options...
        </div>
      )}

      {!loading && options.length === 0 && (
        <p className="text-[12px] text-gray-400 italic py-2">No care plan options available.</p>
      )}

      {!loading && options.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-2.5 gap-x-2 mb-3 text-xs font-medium text-gray-700">
          {options.map((act) => {
            const code = act.carePlanCode || act.code || act.id;
            const name = act.carePlanName || act.name || act.description || "";
            const checked = isChecked(code);
            return (
              <label
                key={code}
                className="flex items-center gap-2 cursor-pointer hover:text-teal-800 transition"
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => handleToggleActivity(act)}
                  className="rounded text-teal-600 focus:ring-teal-500"
                />
                <span className={checked ? "text-teal-900 font-semibold" : ""}>
                  {name}
                </span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}

